"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const material_1 = require("@mui/material");
const styled_1 = require("./styled");
const Message = () => {
    const { message } = (0, react_router_1.useParams)();
    return ((0, jsx_runtime_1.jsx)(styled_1.StyledContainer, { children: (0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", sx: { width: "fit-content" }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `messages.${message}` }) }) }));
};
exports.Message = Message;
//# sourceMappingURL=index.js.map